module.exports = __webpack_public_path__ + "img/Motorola T100 Talkabout Radio, 2 Pack Black.dfd06fee.jpg";